import api from "@/services/employee";
import moment from "moment";
import i18n from '../../i18n.js'
export default {
  namespaced: true,
  state() {
    return {
      employees: [],
      trackGPS: [],
      loading: true,
      pagination: {
        page: 1,
        page_size: 10,
      },
    };
  },
  mutations: {
    set_trackGPS(state, data) {
      state.trackGPS.push(data);
    },
    set_employees(state, { data }) {
      state.pagination = data.pagination;
      state.employees = data.rows;
      state.loading = false;
    },
    set_new(state, { data }) {
      state.employees.push(data);
      // state.loading = false;
    },
    set_employees_null(state) {
      state.employees = [];
      state.loading = false;
    },
  },
  getters: {
    employees(state) {
      return state.employees;
    },
    trackGPS(state) {
      return state.trackGPS;
    },
    loading(state) {
      return state.loading;
    },
  },
  actions: {
    list({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .list()
          .then((res) => {
            if (res.status == 200) {
              commit("set_employees", res.data);
              resolve(res);
            }
            else {
              commit("set_employees_null");
              reject()
            }


          })
          .catch((err) => {
            commit("set_employees_null");
          });
      });
    },
    addOne({ dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        api
          .add(payload)
          .then((res) => {
            dispatch("api/handleServiceException", { e: res }, { root: true });
            commit("set_new", res.data);
            resolve(res);
          })
          .catch((err) => {
            dispatch("api/handleServiceException", { e: err }, { root: true });
            reject(err);
          });
      });
    },
    update({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        api
          .update(payload)
          .then((res) => {
            dispatch("api/handleServiceException", { e: res }, { root: true });

            resolve(res);
          })
          .catch((err) => {
            dispatch("api/handleServiceException", { e: err }, { root: true });
            reject(err);
          });
      });
    },
    trackGPS({ state, commit }, data) {
      if (data.success === true) {
        // var foundIndex = state.trackGPS.findIndex((x) => x.id == data.id);
        // if (foundIndex == -1)
           commit("set_trackGPS", data);
        // else state.trackGPS[foundIndex] = data;
      } else console.log("serror  geo->", data.message);
    },
    offline({ state, commit }, id) {
      try {
        var foundIndex = state.employees.findIndex((x) => x.id == id);
        state.employees[foundIndex].at_work = 0;
        state.employees[foundIndex].updated_at = moment.now();
        // commit(
        //   "error",
        //   {
        //     showType: "toast",
        //     position: "bottom-right",
        //     title: "info",
        //     text: i18n.t("analys.tableEmployee.disactive") + " " + state.employees[foundIndex].name,
        //   },
        //   { root: true }
        // );
      } catch (e) { }
    },
    online({ state, commit }, id) {
      try {
        var foundIndex = state.employees.findIndex((x) => x.id == id);
        state.employees[foundIndex].at_work = 1;
        state.employees[foundIndex].updated_at = moment.now();

        // commit(
        //   "success",
        //   {
        //     showType: "toast",
        //     position: "bottom-right",
        //     title: "info",
        //     text: i18n.t("analys.tableEmployee.active") + " " + state.employees[foundIndex].name
        //   },
        //   { root: true }
        // );
      } catch (e) { console.log(e) }
    },
    deleteOne({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        api
          .delete(payload)
          .then((res) => {
            dispatch("api/handleServiceException", { e: res }, { root: true });

            resolve(res);
          })
          .catch((err) => {
            dispatch("api/handleServiceException", { e: err }, { root: true });
            reject(err);
          });
      });
    },
  },
};
